export default {
  descriptionCostPerFlyer: { color: 'red', marginTop: 5, fontSize: 12 },
}



// WEBPACK FOOTER //
// ./src/Containers/Mission/Details/MissionCosts/styles.js